import {current, total} from './DurationTmpl';
import Util from '../../common/Util';

export default class Duration {
    constructor( _container, _option ){
        this.nameIs = 'class-Duration';
        this.container = _container;
        this.option = _option;

        this.nowData = _option.list[0];
        
        this.current = $( current() );
        this.total = $( total() );

        $(_container).append( this.current, ' / ', this.total );
    }

    addEvents(){}

    setNowVideoData(_d){
        this.nowData = _d;
    }

    update(_total, _current){
        let cur = _current - this.nowData.startSeconds;
        let tot = this.nowData.endSeconds - this.nowData.startSeconds;

        this.current.text(Util.makeTime(Util.cleanSec(cur)));
        this.total.text(Util.makeTime(Util.cleanSec(tot)));
    }

    
} // end of class